import { defineComponent } from 'nest/platform/models';
import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { CONNECTION_SETTINGS_MODAL_COMPONENT, NC_PLATFORM_NAME } from '../constants';
export const connectionSettingsModalComponentDef = defineComponent(CONNECTION_SETTINGS_MODAL_COMPONENT, {
  path: `/connections-embed/${getPortalId()}/navigation-modal`,
  name: CONNECTION_SETTINGS_MODAL_COMPONENT,
  platformName: NC_PLATFORM_NAME,
  capabilities: [capabilities.HIDE_COMPONENT_CAP.getName()],
  iframeProps: {
    style: {
      width: 0,
      height: 0
    }
  }
});